import { Equivalence } from '../Equivalence/index.js';
export const eq = (a, b) => {
    return Equivalence.Number(a.x, b.x) && Equivalence.Number(a.y, b.y);
};
//# sourceMappingURL=Point.js.map